import { InertiaLink } from '@inertiajs/inertia-react'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'

export default function HeaderComponent() {
  const { t } = useTranslation()
  return (
    <Button
      color="inherit"
      component={InertiaLink}
      href={route('merchant.employees.create')}
      sx={{ color: 'black' }}
      variant="contained"
    >
      {t('BUTTON.ADD_EMPLOYEE')}
    </Button>
  )
}
